import type { SunProtectionOrderRole } from "./order.types";

/**
 * Derives the order role from the `returnKey` URL param.
 * - `measurement` -> a measurer (inmeter) is filling in the order
 * - `sales` -> sales is adding sun protection to a deal (no PDF, deal ID only)
 * - anything else -> a regular customer order
 */
export function getSunProtectionOrderRole(
    returnKey: string | null,
): SunProtectionOrderRole {
    switch (returnKey) {
        case "measurement":
            return "MEASURER";
        case "sales":
            return "SALES";
        default:
            return "CUSTOMER";
    }
}
